"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var recursiveCategories = function recursiveCategories(categories) {
  var r = [];
  Object.keys(categories).forEach(function (key) {
    if (categories && categories[key]) {
      r.push(key);

      if ('boolean' !== typeof categories[key]) {
        var result = recursiveCategories(categories[key]);

        if (result.length > 0) {
          result.forEach(function (re) {
            return r.push(re);
          });
        }
      }
    }
  });
  return r;
};

exports.default = recursiveCategories;